module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout'), _vm._v(" "), _c('p', [_vm._v("\n        Login to your Twitter account (so we can tell everyone you if you get a question wrong and don't reach the destination in time)")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13dabf68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Login.vue
// module id = 84
// module chunks = 0